import AllRoutes from "./routes/index";
import "./App.css";
import { Provider } from "react-redux";
import configureStore from "./store";
import { PersistGate } from "redux-persist/integration/react";
const { store, persistor } = configureStore();
const unsubscribe = store.subscribe(() => {
  // console.log("STORE SUBSCRIBE: cashedout? : ", store.getState().auth.cashedOut);
  // console.log("STORE SUBSCRIBE: GAME : ", store.getState().game);
});
function App() {
  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <AllRoutes />
      </PersistGate>
    </Provider>
  );
}

export default App;
